import { BREAKPOINT_MEDIA_QUERIES } from '../utils/breakpoints';
import { hasOpenOverlay, Overlay, toggleOverlay } from '../utils/overlays';

const navbarElement = document.querySelector<HTMLElement>('.navbar');
const navbarTogglerElement =
  navbarElement?.querySelector<HTMLButtonElement>('.navbar__toggler');

if (navbarElement && navbarTogglerElement) {
  navbarTogglerElement.addEventListener('click', () => {
    toggleOverlay(
      Overlay.MENU,
      navbarElement.classList.toggle(
        'navbar--open',
        !hasOpenOverlay(Overlay.MENU),
      ),
    );
  });

  const navbarTransitionMediaQueryFix = () => {
    navbarElement.classList.add('navbar--no-transitions');
    setTimeout(() => {
      navbarElement.classList.remove('navbar--no-transitions');
    }, 0);
  };
  BREAKPOINT_MEDIA_QUERIES.lg.addEventListener(
    'change',
    navbarTransitionMediaQueryFix,
  );
}
